<template>
  <div class="flex flex-wrap justify-start gap-16">
    <template v-for="logo in logos" :key="logo">
      <BCorpLogo v-if="logo === 'bcorp'" class="shrink-0" />
      <BBBLogo v-else-if="logo === 'bbb'" class="shrink-0" />
      <CustomerServiceOfTheYearLogo
        v-else-if="logo === 'customer-service-of-the-year'"
        class="shrink-0"
      />
      <BestECommerceWebsiteLogo
        v-else-if="logo === 'best-e-commerce-website'"
        class="shrink-0"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import BBBLogo from '~/scopes/navigation/components/Footer/BBBLogo.vue'
import BCorpLogo from '~/scopes/navigation/components/Footer/BCorpLogo.vue'
import BestECommerceWebsiteLogo from '~/scopes/navigation/components/Footer/BestECommerceWebsiteLogo.vue'
import CustomerServiceOfTheYearLogo from '~/scopes/navigation/components/Footer/CustomerServiceOfTheYearLogo.vue'

import type { Logo } from '../config/types'

interface Props {
  logos: Logo[]
}

defineProps<Props>()
</script>
